import React from 'react';
import styles from './SalesLeaderboard.module.css';
import { SalesRepItem } from '../salesTypes';

interface SalesLeaderboardProps {
  items: SalesRepItem[];
}

const RankCell: React.FC<{ rank: number }> = ({ rank }) => {
  const isTopThree = rank <= 3;
  return (
    <div className={`${styles.rankCell} ${isTopThree ? styles.rankTop : ''}`}>
      {isTopThree && (
        <svg className={styles.trophyIcon} viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/>
        </svg>
      )}
      <span className={isTopThree ? styles.rankNumberTop : styles.rankNumber}>#{rank}</span>
    </div>
  );
};

const AvatarCell: React.FC<{ initials: string; rank: number }> = ({ initials, rank }) => {
  const colorClass = rank <= 3 ? styles.avatarGold : styles.avatarBlue;
  return (
    <span className={`${styles.avatar} ${colorClass}`}>
      {initials}
    </span>
  );
};

export const SalesLeaderboard: React.FC<SalesLeaderboardProps> = ({ items }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.thRank}>RANK</th>
            <th className={styles.thRep}>SALES REP</th>
            <th className={styles.thRight}>REVENUE</th>
            <th className={styles.thRight}>MARGIN %</th>
            <th className={styles.thRight}>CUSTOMERS</th>
            <th className={styles.thRight}>TARGET</th>
            <th className={styles.thRight}>ACHIEVEMENT</th>
            <th className={styles.thRight}>COMMISSION</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            const isTopThree = item.rank <= 3;
            return (
              <tr key={item.id} className={`${styles.row} ${isTopThree ? styles.rowHighlight : ''}`}>
                <td>
                  <RankCell rank={item.rank} />
                </td>
                <td>
                  <div className={styles.repCell}>
                    <AvatarCell initials={item.initials} rank={item.rank} />
                    <span className={styles.repName}>{item.name}</span>
                  </div>
                </td>
                <td className={styles.numericCell}>
                  ${item.revenue.toLocaleString()}
                </td>
                <td className={`${styles.numericCell} ${styles.marginValue}`}>
                  {item.marginPercent.toFixed(1)}%
                </td>
                <td className={styles.numericCell}>
                  {item.customers}
                </td>
                <td className={styles.numericCell}>
                  ${item.target.toLocaleString()}
                </td>
                <td className={`${styles.numericCell} ${styles.achievementValue}`}>
                  {item.achievement}%
                </td>
                <td className={`${styles.numericCell} ${styles.commissionValue}`}>
                  ${item.commission.toLocaleString()}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
